<template>
    <div style="width:100%;height:100%;position:relative;">
      <div class="flex-wrap" style="padding-right:32px;padding-left:5px;line-height:30px;cursor:pointer" :style="{color:items?'#39f':'#aaa'}" @click="modalSelector=true">
        {{'编辑'}}
      </div>

      <Modal v-model="modalSelector" :width="600" title="表格编辑器" footer-hide>
        <div style="margin:0px;">
          <!-- 顶部按钮栏 -->
          <div class="flex-wrap">
            <div class="toolbar-left">
              <Button size="small" @click="add">
                <Icon type="md-add" size="14" /> 新增
              </Button>
              <Button size="small" @click="batchAddVisible = true" style="margin-left:8px;">
                <Icon type="md-list" size="14" /> 批量添加
              </Button>
            </div>
            <div class="toolbar-right" v-if="hasSelected">
              <Button size="small" :disabled="!canSwapUp" @click="swapup()">
                <Icon type="md-arrow-up" size="14" /> 上移
              </Button>
              <Button size="small" :disabled="!canSwapDown" @click="swapdown()" style="margin-left:6px;">
                <Icon type="md-arrow-down" size="14" /> 下移
              </Button>
              <Button size="small" type="error"  @click="remove()" style="margin-left:6px;">
                <Icon type="md-remove" size="14" /> 删除
              </Button>
            </div>
          </div>

          <!-- 批量添加输入框（点击批量添加后显示） -->
          <div class="batch-add-area" v-if="batchAddVisible">
            <Input
              v-model="batchAddText"
              type="textarea"
              :rows="3"
              placeholder="输入多个列标题，用 空格 / 逗号 / 分号 / | 分隔，例如：姓名 年龄 部门|岗位"
              style="margin-bottom:8px;"
            />
            <div class="flex-wrap flex-right">
              <Button size="small" @click="batchAddVisible = false; batchAddText = ''">取消</Button>
              <Button size="small" type="primary" @click="confirmBatchAdd" style="margin-left:8px;">确定添加</Button>
            </div>
          </div>

          <!-- 下方：左侧列表 + 右侧属性 -->
          <div class="content-row">
            <div class="list-panel">
              <div
                v-for="c in items || []"
                :key="c.key"
                class="col-item"
                :class="{'col-item-selected':selected==c}"
                @click="selected = c"
              >
                {{ c.name || '未命名' }}
              </div>
              <div class="col-item col-item-empty" v-if="!(items && items.length)">
                暂无列，请点击上方新增或批量添加
              </div>
            </div>
            <div class="property-panel">
              <template v-if="hasSelected">
                <BaseProperty v-model="selected" :attrs="Attrs" @on-change="handleChangeProperty" />
                <BaseProperty v-model="selected.config" :attrs="ConfigAttrs || []" v-if="ConfigAttrs.length > 0" />
              </template>
              <div class="property-empty" v-else>
                请在左侧选择一列进行编辑
              </div>
            </div>
          </div>
        </div>
        <div class="flex-wrap flex-right" style="padding-top:10px;">
          <Button @click="save" type="primary" size="large">保存</Button>
          <Button @click="cancel" size="large" style="margin-left:10px;">取消</Button>
        </div>
      </Modal>
    </div>
  </template>
  
  <script>
  import {cloneDeep} from 'lodash';
  export default {
    data() {
      return {
        form: {},
        selected: {},
        modalSelector: false,
        globalID: 0,
        items: [],
        batchAddVisible: false,
        batchAddText: '',
      };
    },
    props: ['value'],
    watch:{
      value:{
        handler(v){
          this.items = cloneDeep(v);
          if(this.items.length > 0){
            if(this.selected.key){
              this.selected = this.items.find((v)=>v.key == this.selected.key)
            }else{
              this.selected = this.items[0]
            }
          }else{
            this.selected = {}
          }
        },
        deep:true,
        immediate:true
      }
    },
    mounted() {
      this.selected = this.items[0];
    },
    methods: {
      emitChange(){
        this.$emit('input',this.items)
        this.$bus.$emit('calc-flex-table')
      },
      swapup() {
        const index = this.items.findIndex((v)=>v == this.selected);
        this.items.splice(index, 1);
        this.items.splice(index-1, 0, this.selected);
      },
      swapdown() {
        const index = this.items.findIndex((v)=>v == this.selected);
        this.items.splice(index, 1);
        this.items.splice(index+1, 0, this.selected);
      },
      createID(){
        let id = 'col'+this.globalID++;
        if(this.items.find((v)=>v.key == id)){
          return this.createID();
        }
        return id;
      },
      handleChangeProperty({key,value}){
        const needConfigControls = ['ZzlInputSelect', 'ZzlMultiSelect', 'ZzlRadio'];
        if(key=='type'){
          if(needConfigControls.includes(value) && !this.selected.config){
            this.selected.config = {
              options:[],
              simple:true
            };
          }else{
            this.selected.config = {};
          }
        }
      },
      add() {
        this.items.push({
          name: '列'+this.createID(),
          control: 'ZzlInput',
          key: this.createID(),
          width:'auto',
          align:'center',
          config:{
            options:[],
            simple:true
          }
        });
      },
      remove() {
        const index = this.items.findIndex((v)=>v == this.selected);
        this.items.splice(index, 1);
        this.selected = this.items[index] || this.items[index - 1] || {};
  
      },
      confirmBatchAdd() {
        const raw = (this.batchAddText || '').trim();
        if (!raw) {
          this.$Message.warning('请输入要添加的列标题');
          return;
        }
        const parts = raw.split(/[\s,;|]+/).map(s => s.trim()).filter(Boolean);
        if (!parts.length) {
          this.$Message.warning('未识别到有效列标题');
          return;
        }
        parts.forEach(name => {
          this.items.push({
            name: name,
            control: 'ZzlInput',
            key: this.createID(),
            width: 'auto',
            align: 'center',
            config: { options: [], simple: true },
          });
        });
        this.batchAddVisible = false;
        this.batchAddText = '';
        this.selected = this.items[this.items.length - 1];
        this.$Message.success(`已添加 ${parts.length} 列`);
      },
      save() {
        this.emitChange();
        this.modalSelector = false;
      },
      cancel(){
        this.modalSelector = false
        this.$emit('on-cancel')
      }
    },
    computed: {
      hasSelected() {
        return this.selected && this.selected.key && this.items && this.items.some(c => c === this.selected);
      },
      canSwapUp() {
        if (!this.hasSelected) return false;
        const index = this.items.findIndex(v => v === this.selected);
        return index > 0;
      },
      canSwapDown() {
        if (!this.hasSelected) return false;
        const index = this.items.findIndex(v => v === this.selected);
        return index >= 0 && index < this.items.length - 1;
      },
      Attrs() {
        const fields = [{
          label: '名称',
          key: 'name',
          control: 'Text',
          editable: true,
        },
         
         {
          label: '类型',
          key: 'control',
          editable: true,
          control: 'Select',
          option: {
            options: [{
              label: '单行文本',
              value: 'ZzlInput',
            }, {
              label: '数值',
              value: 'ZzlNumber',
            }, {
              label: '多行文本',
              value: 'ZzlTextarea',
            }, {
              label: '日期',
              value: 'ZzlDate',
            }, {
              label: '单选',
              value: 'ZzlRadio',
            }, {
              label: '输入选择框',
              value: 'ZzlInputSelect',
            }, {
              label: '文件',
              value: 'ZzlFileUpload',
            }, {
              label: '图片',
              value: 'ZzlImage',
            },{
              label: '多选选择框',
              value: 'ZzlMultiSelect',
            }],
            defaultTo: 'ZzlInput',
          },
        }, {
          label: '宽度',
          key: 'width',
          editable: true,
          option:{
            placeholder: '请输入宽度(固定宽度或百分比，如100或100%)',
          },
          control: 'Number',
          defaultTo:undefined
        }, {
          label: '对齐',
          key: 'align',
          editable: true,
          control: 'Select',
          option: {
            options: [{
              label: '左对齐',
              value: 'left',
            }, {
              label: '居中',
              value: 'center',
            }, {
              label: '右对齐',
              value: 'right',
            }],
          },
        }, {
          label: '必填',
          key: 'required',
          editable: true,
          control: 'Check',
        },
        /*{
          label: '默认值',
          key: 'defaultValue',
          editable: true,
          control: 'DefaultValue',
          option: {
            control: this.selected,
          },
        }*/
        ]
        return [...fields];
      },
      ConfigAttrs() {
        let extra = [];
        const optionControls = ['ZzlInputSelect', 'ZzlMultiSelect', 'ZzlRadio'];
        if (this.selected && optionControls.includes(this.selected.control)) {
          extra = [{
            key: 'options',
            control: 'SelectOption',
            editable: true,
            option:{
              simple:true,
            },
            label: '选项',
          }];
        }
        return extra;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .toolbar-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    border-bottom: 1px solid var(--border);
    background: var(--bg-sub);
  }
  .toolbar-left { display: flex; align-items: center; }
  .toolbar-right { display: flex; align-items: center;margin-left:10px; }

  .batch-add-area {
    padding: 10px 12px;
    border-bottom: 1px solid var(--border);
    background: var(--bg-sub);
  }

  .content-row {
    display: flex;
    min-height: 320px;
    align-items: stretch;
    margin-top:10px;
    border:1px solid var(--border)
  }
  .list-panel {
    width: 180px;
    min-width: 180px;
    border-right: 1px solid var(--border);
    overflow-y: auto;
    flex-shrink: 0;
  }
  .property-panel {
    flex: 1;
    margin: 10px 12px;
    border:1px solid var(--border);
    overflow-y: auto;
    min-width: 0;
  }
  .property-empty {
    color: var(--text-tertiary, #999);
    padding: 20px;
    text-align: center;
  }

  .col-item {
    height: 36px;
    padding: 0 10px;
    cursor: pointer;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    font-size: 13px;
  }
  .col-item:hover { background: var(--hover-bg, rgba(0,0,0,.04)); }
  .col-item-selected {
    background: var(--primary);
    color: var(--hover-text);
  }
  .col-item-selected:hover { background: var(--primary); color: var(--hover-text); }
  .col-item-empty {
    color: var(--text-tertiary, #999);
    cursor: default;
    justify-content: center;
  }
  </style>
  